import { gql } from '@apollo/client';

export const GET_YARDS = gql`
  query GetYards(
    $limit: Float
    $skip: Float
    $sortOrder: String
    $sortBy: String
    $yardInput: QueryYardInput!
  ) {
    getYards(
      limit: $limit
      skip: $skip
      sortOrder: $sortOrder
      sortBy: $sortBy
      yardInput: $yardInput
    ) {
      yards {
        id
        createdAt
        updatedAt
        nameExternal
        nameInternal
        marketId
        vendor
        address
        spots
        status
        contactName
        contactNumber
        secure
      }
      total
    }
  }
`;

export const SEARCH_YARDS_BY_NAME_AND_ADDRESS = gql`
  query SearchYardsByNameAndAddress(
    $searchText: String!
    $sortBy: String
    $sortOrder: String
    $offset: Float
    $limit: Float
  ) {
    searchYardsByNameAndAddress(
      searchText: $searchText
      sortBy: $sortBy
      sortOrder: $sortOrder
      offset: $offset
      limit: $limit
    ) {
      total
      yards {
        id
        createdAt
        updatedAt
        nameExternal
        nameInternal
        marketId
        vendor
        address
        spots
        status
        contactName
        contactNumber
        secure
      }
    }
  }
`;
